import {
    createEventEmitter,
    MINT_EVENTS,
    DEPOSIT_EVENTS,
    WITHDRAW_EVENTS,
    LOCK_EVENTS,
    REDEEM_EVENTS,
    STAKE_EVENTS,
    REALLOCATE_POINTS_EVENTS,
    CANCEL_EXIT_EVENTS,
    CLAIM_EVENTS,
    type RedeemSuccessPayload,
    type LockSuccessPayload,
    type MintSuccessPayload,
    type DepositSuccessPayload,
    type WithdrawSuccessPayload,
    type StakeSuccessPayload,
    type ReallocatePointsSuccessPayload,
    type LockWithdrawPayload,
    type CancelExitSuccessPayload,
    type ClaimSuccessPayload,
    type MultiVoteSuccessPayloads,
    MULTIVOTE_EVENTS,
} from "@/events";
import { GENERIC_TRANSACTION_EVENTS, type GenericTransactionFailedPayload } from "./generic-transaction.events";

export const TOAST_EVENTS = {
    MINT_SUCCESS: MINT_EVENTS.SUCCESS,
    DEPOSIT_SUCCESS: DEPOSIT_EVENTS.SUCCESS,
    WITHDRAW_SUCCESS: WITHDRAW_EVENTS.SUCCESS,
    LOCK_SUCCESS: LOCK_EVENTS.SUCCESS,
    REDEEM_SUCCESS: REDEEM_EVENTS.SUCCESS,
    STAKE_SUCCESS: STAKE_EVENTS.SUCCESS,
    REALLOCATE_POINTS_SUCCESS: REALLOCATE_POINTS_EVENTS.SUCCESS,
    WITHDRAW_LOCK_SUCCESS: LOCK_EVENTS.WITHDRAW,
    CANCEL_EXIT_SUCCESS: CANCEL_EXIT_EVENTS.SUCCESS,
    CLAIM_SUCCESS: CLAIM_EVENTS.SUCCESS,
    MULTIVOTE_SUCCESS: MULTIVOTE_EVENTS.SUCCESS,
    GENERIC_TRANSACTION_FAILED: GENERIC_TRANSACTION_EVENTS.FAILED,
} as const;

export type ToastEvents = (typeof TOAST_EVENTS)[keyof typeof TOAST_EVENTS];

export type ToastEventPayloads = {
    [TOAST_EVENTS.MINT_SUCCESS]: MintSuccessPayload;
    [TOAST_EVENTS.DEPOSIT_SUCCESS]: DepositSuccessPayload;
    [TOAST_EVENTS.WITHDRAW_SUCCESS]: WithdrawSuccessPayload;
    [TOAST_EVENTS.LOCK_SUCCESS]: LockSuccessPayload;
    [TOAST_EVENTS.REDEEM_SUCCESS]: RedeemSuccessPayload;
    [TOAST_EVENTS.STAKE_SUCCESS]: StakeSuccessPayload;
    [TOAST_EVENTS.REALLOCATE_POINTS_SUCCESS]: ReallocatePointsSuccessPayload;
    [TOAST_EVENTS.WITHDRAW_LOCK_SUCCESS]: LockWithdrawPayload;
    [TOAST_EVENTS.CANCEL_EXIT_SUCCESS]: CancelExitSuccessPayload;
    [TOAST_EVENTS.CLAIM_SUCCESS]: ClaimSuccessPayload;
    [TOAST_EVENTS.MULTIVOTE_SUCCESS]: MultiVoteSuccessPayloads;
    [TOAST_EVENTS.GENERIC_TRANSACTION_FAILED]: GenericTransactionFailedPayload;
};

export const toastEventEmitter = createEventEmitter<ToastEventPayloads>();
